import $ from 'jquery';

// -------------------------------------------------------------------------------------------------
// Variables
// -------------------------------------------------------------------------------------------------

const baseClass = 'ume-counter';

// -------------------------------------------------------------------------------------------------
// Classes
// -------------------------------------------------------------------------------------------------

class counterBlock {
  constructor(el) {
    this.el = el;
    this.observer();
  }

  observer() {
    function commaSeparateNumber(val) {
      while (/(\d+)(\d{3})/.test(val.toString())) {
        val = val.toString().replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1.');
      }
      return val;
    }

    const allCounterBlocks = document.querySelectorAll(`.${baseClass}`);

    const counterObserver = new IntersectionObserver((entries, observer) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          if (!$(entry.target).hasClass('is-finish')) {
            const $this = $(entry.target);
            const classCountNumber = `.${baseClass}__number`;
            const countTo = $this.find(classCountNumber).find('[data-counter]').attr('data-counter');

            $({countNum: $this.find(classCountNumber).text()}).animate({countNum: countTo}, {
                duration: 3000,
                easing: 'linear',

                step: function () {
                  $this.find(classCountNumber).find('[data-counter]').text(Math.floor(this.countNum));
                },
                complete: function () {
                  $this.find(classCountNumber).find('[data-counter]').text(commaSeparateNumber(this.countNum));
                  $(entry.target).addClass('is-finish')
                },
              });
          }

        }
      });
    }, {rootMargin: '0px'});
    allCounterBlocks.forEach(item => {
      counterObserver.observe(item);
    })
  }
}

// -------------------------------------------------------------------------------------------------
// Methods
// -------------------------------------------------------------------------------------------------

function init() {
  $(`.${baseClass}`).each((i, el) => new counterBlock(el));
}

// -------------------------------------------------------------------------------------------------
// Export
// -------------------------------------------------------------------------------------------------

export default {
  init,
};